import { FormattedEvent } from '@eb/event-renderer';

export const CREATOR_COLLECTIONS_FORMATTED_RESPONSE: FormattedEvent[] = [
    {
        id: '10629780961',
        minPrice: {
            currency: 'USD',
            currencyFormat: '¤#,##0.00',
            minPriceValue: 2500,
        },
        isSoldOut: false,
        eventSalesStatus: {
            salesStatus: 'on_sale',
            message: '',
            messageType: '',
            messageCode: '',
        },
        imageUrl:
            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068193%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=4bafbe8cca69507baa336787cc6116fd',
        edgeColor: undefined,
        locationInfo: 'Reno, NV',
        startTime: '08:00',
        startDate: '2038-01-01',
        isFree: false,
        ticketsBy: 'Eventbrite',
        name:
            'Book Purchase: Water-Efficient Landscaping in the Intermountain West',
        savedByYou: true,
        url:
            'https://www.evbqa.com/e/book-purchase-water-efficient-landscaping-in-the-intermountain-west-tickets-10629780961',
        isOnlineEvent: false,
        timezone: 'America/Los_Angeles',
        organizerId: '6076001355',
        organizerName: 'University of Nevada Cooperative Extension',
        organizerFollowerCount: 27,
    },
    {
        id: '11038260735',
        minPrice: {
            currency: 'USD',
            currencyFormat: '¤#,##0.00',
            minPriceValue: 500,
        },
        isSoldOut: false,
        eventSalesStatus: {
            salesStatus: 'on_sale',
            message: '',
            messageType: '',
            messageCode: '',
        },
        imageUrl:
            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F5413189%2F89561036269%2F1%2Foriginal.jpg?w=206&auto=format%2Ccompress&q=75&sharp=10&s=bd95dfae88aa473f67188af4a314916b',
        edgeColor: undefined,
        locationInfo: '',
        startTime: '14:00',
        startDate: '2038-01-01',
        isFree: false,
        ticketsBy: 'Eventbrite',
        name:
            'Book Purchase: Home Landscaping Guide for Lake Tahoe and Vicinity',
        savedByYou: true,
        url:
            'https://www.evbqa.com/e/book-purchase-home-landscaping-guide-for-lake-tahoe-and-vicinity-tickets-11038260735',
        isOnlineEvent: true,
        timezone: 'America/Los_Angeles',
        organizerId: '6076001355',
        organizerName: 'University of Nevada Cooperative Extension',
        organizerFollowerCount: 27,
    },
    {
        id: '10630354677',
        minPrice: {
            currency: 'USD',
            currencyFormat: '¤#,##0.00',
            minPriceValue: 2500,
        },
        isSoldOut: false,
        eventSalesStatus: {
            salesStatus: 'on_sale',
            message: '',
            messageType: '',
            messageCode: '',
        },
        imageUrl:
            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068203%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=7286c86e796c60c8cfb3226a93a7a08b',
        edgeColor: undefined,
        locationInfo: '',
        startTime: '08:00',
        startDate: '2038-01-01',
        isFree: false,
        ticketsBy: 'Eventbrite',
        name: 'Book Purchase: Evaluating Alternative Low-Water-Use Crops',
        savedByYou: false,
        url:
            'https://www.evbqa.com/e/book-purchase-evaluating-alternative-low-water-use-crops-tickets-10630354677',
        isOnlineEvent: true,
        timezone: 'America/Los_Angeles',
        organizerId: '6076001355',
        organizerName: 'University of Nevada Cooperative Extension',
        organizerFollowerCount: 27,
    },
    {
        id: '10630657583',
        minPrice: {
            currency: 'USD',
            currencyFormat: '¤#,##0.00',
            minPriceValue: 500,
        },
        isSoldOut: false,
        eventSalesStatus: {
            salesStatus: 'on_sale',
            message: '',
            messageType: '',
            messageCode: '',
        },
        imageUrl:
            'https://img-dev.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F87068223%2F89561036269%2F1%2Foriginal.png?w=512&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C0%2C50000%2C50000&s=8a2d334faff98bbd1722229921c25004',
        edgeColor: undefined,
        locationInfo: '',
        startTime: '08:00',
        startDate: '2038-01-01',
        isFree: false,
        ticketsBy: 'Eventbrite',
        name: 'Book Purchase: Complete Guide to Home Canning',
        savedByYou: false,
        url:
            'https://www.evbqa.com/e/book-purchase-complete-guide-to-home-canning-tickets-10630657583',
        isOnlineEvent: true,
        timezone: 'America/Los_Angeles',
        organizerId: '6076001355',
        organizerName: 'University of Nevada Cooperative Extension',
        organizerFollowerCount: 27,
    },
];
